import apiClient from "../apiClient";

export const getRoutesAPI = async (_id) => {
  try {
    const routesData = await apiClient.get(`rutasMapa/getRouteUserById/${_id}`);
    return routesData?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const addNewRoute = async (newDataRdoute) => {
  try {
    const response = await apiClient.post(
      "rutasMapa/create-route",
      newDataRdoute
    );
    return response?.data?.route;
  } catch (error) {
    throw error;
  }
};

export const shareRoute = async (routeId) => {
  try {
    const response = await apiClient.patch(`rutasMapa/share-route/${routeId}`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getAllRoutesPublicAPI = async () => {
  try {
    const response = await apiClient.get("rutasMapa/routesPublicAll");
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const getRoutesAssignedAPI = async () => {
  try {
    const response = await apiClient.get("rutasAssigment/getRouteByRunner");
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};
export const getRoutesAssignedCoachAPI = async (userId) => {
  try {
    const response = await apiClient.get(
      `rutasAssigment/getRouteAsgById/${userId}`
    );
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};

export const AssigmentRouteOfRunner = async (data) => {
  try {
    // console.log("Datos a enviar", data);

    const response = await apiClient.post(
      "rutasAssigment/create-route/Assign",
      data
    );
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
};
